"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalActions", {
  enumerable: true,
  get: function get() {
    return _ModalStyled.StyledModalActions;
  }
});

var _Modal = _interopRequireDefault(require("./Modal"));

var _ModalStyled = require("./Modal-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }